var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "100px" },
          attrs: {
            title: _vm.title,
            width: 620,
            visible: _vm.visible,
            confirmLoading: _vm.confirmLoading,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            mask: _vm.isDesktop(),
            maskClosable: false,
            cancelText: "取消",
            okText: "保存",
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
        },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.confirmLoading } },
            [
              _c(
                "a-form",
                { attrs: { form: _vm.form } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "素材类型",
                      },
                    },
                    [
                      _c(
                        "a-radio-group",
                        {
                          attrs: { buttonStyle: "solid" },
                          model: {
                            value: _vm.mediaType,
                            callback: function ($$v) {
                              _vm.mediaType = $$v
                            },
                            expression: "mediaType",
                          },
                        },
                        [
                          _c("a-radio-button", { attrs: { value: "image" } }, [
                            _vm._v("图片"),
                          ]),
                          _c("a-radio-button", { attrs: { value: "video" } }, [
                            _vm._v("视频"),
                          ]),
                        ],
                        1
                      ),
                      _c("span", { staticClass: "field-tip" }, [
                        _vm._v("图片按时长轮播；视频播放完或到时切下一条"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "素材",
                        required: "",
                      },
                    },
                    [
                      _c("j-upload", {
                        attrs: {
                          fileType: _vm.mediaType === "image" ? "image" : "all",
                          bizPath: "material",
                          number: 1,
                          value: _vm.mediaUrl,
                          text: "上传素材",
                        },
                        on: { change: _vm.onMediaChange },
                      }),
                      _c("div", { staticClass: "field-tip" }, [
                        _vm._v(
                          "支持 jpg/png/gif 图片、mp4/avi 视频，大小受平台上传限制"
                        ),
                      ]),
                      _vm.mediaUrl
                        ? _c("div", { staticClass: "media-preview" }, [
                            _vm.mediaType === "image"
                              ? _c("img", {
                                  attrs: { src: _vm.mediaDisplayUrl },
                                })
                              : _c("video", {
                                  attrs: {
                                    src: _vm.mediaDisplayUrl,
                                    controls: "",
                                  },
                                }),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                        label: "备注名",
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["title"],
                            expression: "['title']",
                          },
                        ],
                        attrs: {
                          placeholder: "可选，副屏底部展示",
                          maxLength: 100,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: { span: 8 },
                                wrapperCol: { span: 14 },
                                label: "排序",
                              },
                            },
                            [
                              _c("a-input-number", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: ["sortNo", { initialValue: 0 }],
                                    expression:
                                      "['sortNo', { initialValue: 0 }]",
                                  },
                                ],
                                staticStyle: { width: "100%" },
                                attrs: {
                                  min: 0,
                                  precision: 0,
                                  placeholder: "数字越小越先播",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                labelCol: { span: 8 },
                                wrapperCol: { span: 14 },
                                label: "时长(秒)",
                              },
                            },
                            [
                              _c("a-input-number", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "duration",
                                      _vm.validatorRules.duration,
                                    ],
                                    expression:
                                      "['duration', validatorRules.duration]",
                                  },
                                ],
                                staticStyle: { width: "100%" },
                                attrs: {
                                  min: 1,
                                  max: 600,
                                  precision: 0,
                                  placeholder: "图片展示/视频播放时长",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }